import axios from 'axios';
import { setLoading, setModuleLoading } from '../slices/loadingSlice';
import { store } from '../store';
import { baseURL } from '../../components/config';
import { errorToast, showToast } from './../../utils/toast';
import { handleLogout } from '../../utils';

const axiosInstance = axios.create({
    baseURL,
});

axiosInstance.interceptors.request.use(
    async (config) => {
        let token = localStorage.getItem('token');

        if (token) {
            token = JSON.parse(localStorage.getItem('token'));
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    async (error) => {
        if (error?.response?.status === 401) {
            handleLogout();
            return;
        }
        return Promise.reject(error);
    }
);

const handleRequest =
    (method) =>
        async (url, data, config = {}) => {

            const defaultConfig = {
                loading: true,
                module: null,
                toast: true,
                throwError: true,
                responseType: 'json',
            };

            const finalConfig = { ...defaultConfig, ...config };

            if (!navigator.onLine) return;
            try {
                const { loading, module } = finalConfig;

                store.dispatch(setModuleLoading(module));
                if (loading || loading === undefined) store.dispatch(setLoading(true));

                const response = await axiosInstance.request({
                    method,
                    url,
                    data,
                    ...{ ...finalConfig, signal: finalConfig.signal },
                });

                if (finalConfig.toast) {
                    if (method !== 'get') {
                        if (response?.data?.ack) showToast(response?.data?.message);
                        else errorToast(response?.data?.message);
                    } else if (!response?.data?.ack) {
                        errorToast(response?.data?.message);
                    }
                }

                return finalConfig.responseType === 'blob' ? response : response?.data;
            } catch (error) {
                if (error.code === 'ERR_CANCELED') return error.code;
                if (error?.response?.status === 401) {
                    handleLogout();
                    return;
                } else if (error?.response?.status === 403) {
                    window.location.href = '/';
                }
                errorToast(error?.response?.data?.message || 'Something went wrong.');
            } finally {
                store.dispatch(setLoading(false));
                if (module) store.dispatch(setModuleLoading(null));
            }
        };

const handleGetRequest = handleRequest('get');
const handlePostRequest = handleRequest('post');
const handlePutRequest = handleRequest('put');
const handleDeleteRequest = handleRequest('delete');
const handlePatchRequest = handleRequest('patch');

export {
    handleDeleteRequest,
    handleGetRequest,
    handlePatchRequest,
    handlePostRequest,
    handlePutRequest,
};
